<div class="ev-vcard" (click)="onOpen()">
  <div class="ev-vcard-media">
    <app-event-media class="ev-vcard-image" [item]="media" [alt]="event.title || ''"></app-event-media>

    <app-event-business-info class="ev-vcard-biz" *ngIf="showBusinessInfo"
      [event]="event" variant="filled">
    </app-event-business-info>

    <app-event-price-pill class="ev-vcard-price" [event]="event"></app-event-price-pill>

    <!-- Straddles the image's bottom edge, as on iOS. -->
    <app-event-promotion-badge class="ev-vcard-promo" *ngIf="hasPromotion"></app-event-promotion-badge>
  </div>

  <div class="ev-vcard-body">
    <h3 class="ev-vcard-title">{{ event.title }}</h3>

    <div class="ev-vcard-facts">
      <span class="ev-vcard-fact ev-vcard-date" *ngIf="date">
        <app-event-icon name="calendar" [size]="12"></app-event-icon>
        <span>{{ date }}</span>
      </span>

      <span class="ev-vcard-fact ev-vcard-time" *ngIf="time">
        <app-event-icon name="clock" [size]="12"></app-event-icon>
        <span>{{ time }}</span>
      </span>

      <button type="button" class="ev-vcard-calendar" (click)="onCalendar($event)"
              [attr.aria-label]="'events.addToCalendar' | translate">
        <app-event-icon name="calendar-add" [size]="20"></app-event-icon>
      </button>
    </div>
  </div>
</div>
